module.exports = __webpack_public_path__ + "static/media/logout.0c6b5ed0.svg";